import React, { useContext } from 'react'
import YotpoStars from 'src/components/YotpoStars'
import theme from 'src/utils/styles/theme'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import Analytics from 'src/utils/Analytics'
import { HiddenOnDesktop, HiddenOnMobile } from 'src/utils/styles/global-styles'
import PropTypes from 'prop-types'
import { BuyNowLink } from '../Hero/styles'
import StoreContext from '../../context/StoreContext'
import { TextContainer } from '../HomepageHero/styles'

import {
  Heading,
  Container,
  ImageContainer,
  CtaContainer,
  LogoImageContainer,
  SubHeading,
  SyncsHeader,
  SyncsSection,
  Flexbox,
} from './styles'
import { BUY_LINK, CAL_BUY_LINK, FRAME_2_WALNUT_BUY_LINK } from '../../utils/constants'

export default function HomepageCalHero({ page }) {
  const data = useStaticQuery(graphql`
    query HomepageCalHeroQuery {
      calBackground: file(relativePath: { eq: "homepage/calendar-on-counter-desktop.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundMD: file(relativePath: { eq: "homepage/calendar-on-counter-desktop-md.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundCalendarMD: file(
        relativePath: { eq: "homepage/calendar-on-counter-desktop-calendar-md.webp" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      frame2BackgroundMD: file(relativePath: { eq: "homepage/frame-2-desktop-md.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundMobile: file(relativePath: { eq: "homepage/calendar-on-counter-mobile.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundMobileMD: file(
        relativePath: { eq: "homepage/calendar-on-counter-mobile-md.webp" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calBackgroundCalendarMobileMD: file(
        relativePath: { eq: "homepage/calendar-on-counter-calendar-mobile-md.webp" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      frame2BackgroundMobileMD: file(relativePath: { eq: "homepage/frame-2-md-mobile.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      google: file(relativePath: { eq: "icons/google.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      outlook: file(relativePath: { eq: "icons/outlook.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      apple: file(relativePath: { eq: "icons/apple.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      cozi: file(relativePath: { eq: "icons/cozi.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      yahoo: file(relativePath: { eq: "icons/yahoo.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)

  const calendarList = [
    { id: 'google', label: 'Google' },
    { id: 'outlook', label: 'Outlook' },
    { id: 'apple', label: 'Apple' },
    { id: 'cozi', label: 'Cozi' },
    { id: 'yahoo', label: 'Yahoo' },
  ]
  const {
    store: {
      banner: { promoCode },
    },
  } = useContext(StoreContext)
  const HEADING_OVERRIDE = {
    MDVIP: 'For the Mom Who Does It All',
    calendar: 'Drop the Stress. Not the Ball.',
    frame2: 'Perfect in Every Room',
  }
  const SUBHEADING_OVERRIDE = {
    MDVIP: `This Mother's Day, surprise her with the best-selling tech keeping families connected and schedules in sync.`,
    calendar:
      'Get the whole family organized with chore charts, dinner planning, and customizable lists — all on one display the whole family can use.',
    frame2: `Our best-selling smart photo frame just got even better. And with our new Snap Frames, you don't have to choose a color - you can have them all.`,
  }
  const image =
    promoCode === 'MDVIP'
      ? page === 'calendar'
        ? data.calBackgroundCalendarMD.childImageSharp.gatsbyImageData
        : page === 'frame2'
        ? data.frame2BackgroundMD.childImageSharp.gatsbyImageData
        : data.calBackgroundMD.childImageSharp.gatsbyImageData
      : data.calBackground.childImageSharp.gatsbyImageData

  const mobileImage =
    promoCode === 'MDVIP'
      ? page === 'calendar'
        ? data.calBackgroundCalendarMobileMD.childImageSharp.gatsbyImageData
        : page === 'frame2'
        ? data.frame2BackgroundMobileMD.childImageSharp.gatsbyImageData
        : data.calBackgroundMobileMD.childImageSharp.gatsbyImageData
      : data.calBackgroundMobile.childImageSharp.gatsbyImageData

  const CTA_OVERRIDE = { calendar: 'Buy Now', frame2: 'Buy Now' }
  return (
    <Container mday={promoCode === 'MDVIP'}>
      <HiddenOnDesktop>
        <ImageContainer>
          <GatsbyImage
            image={mobileImage}
            alt='Skylight Calendar 15" on a countertop with a plant and bookcase in the background'
          />
        </ImageContainer>
      </HiddenOnDesktop>
      <TextContainer singleSlide>
        <YotpoStars color={theme.orange} textcolor="#444444" productId="7073751498804" />
        <Heading mday={promoCode === 'MDVIP'}>
          {HEADING_OVERRIDE[page] ||
            HEADING_OVERRIDE[promoCode] ||
            'The All-In-One Smart Family Calendar'}
        </Heading>
        <SubHeading>
          {SUBHEADING_OVERRIDE[page] ||
            SUBHEADING_OVERRIDE[promoCode] ||
            'Get the whole family organized with scheduling, meal planning, chore charts and customizable lists — all on one beautiful display.'}
        </SubHeading>
        <Flexbox>
          <CtaContainer gap>
            {page !== 'frame2' && (
              <BuyNowLink
                onClick={() => Analytics.track('Clicked Buy Now Calendar Hero on Homepage CTA')}
                to={CAL_BUY_LINK}
              >
                {CTA_OVERRIDE[page] || 'Shop Calendar'}
              </BuyNowLink>
            )}
            {promoCode === 'MDVIP' && page !== 'calendar' && (
              <BuyNowLink
                onClick={() => Analytics.track('Clicked Buy Now Frame Hero on Homepage CTA')}
                to={page === 'frame2' ? FRAME_2_WALNUT_BUY_LINK : BUY_LINK}
              >
                {CTA_OVERRIDE[page] || 'Shop Frame'}
              </BuyNowLink>
            )}
          </CtaContainer>
          {page !== 'frame2' && (
            <SyncsSection>
              <SyncsHeader>Seamlessly auto-syncs with:</SyncsHeader>
              <CtaContainer>
                {calendarList.map(({ id, label }) => (
                  <LogoImageContainer>
                    <GatsbyImage
                      key={id}
                      image={data[id].childImageSharp.gatsbyImageData}
                      alt={`Skylight Calendar is compatible with ${label}`}
                    />
                  </LogoImageContainer>
                ))}
              </CtaContainer>
            </SyncsSection>
          )}
        </Flexbox>
      </TextContainer>
      <HiddenOnMobile>
        <ImageContainer>
          <GatsbyImage
            image={image}
            alt='Skylight Calendar 15" on a countertop with a plant and bookcase in the background'
          />
        </ImageContainer>
      </HiddenOnMobile>
    </Container>
  )
}

HomepageCalHero.propTypes = {
  page: PropTypes.string.isRequired,
}
